import { getAugmentedNamespace } from "./_commonjsHelpers.js";
import * as index from "../external/@mui/styled-engine/index.js";
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(index);
export {
  require$$3 as default
};
//# sourceMappingURL=index4.js.map
